import { createPortal } from 'react-dom';
import { MediaQuery } from '../MediaQuery';
import { VIEWPORT_MEDIA_QUERIES } from './GtxApp';
import { Header as TopHeader } from '../../containers/Header';

interface DefaultTopHeaderProps {
    actions?: React.ReactNode;
    customTitle?: string;
}

const DefaultTopHeader: React.FC<DefaultTopHeaderProps> = ({
    actions,
    customTitle,
}) => (
    <MediaQuery queries={VIEWPORT_MEDIA_QUERIES}>
        {(match) => (
            <>
                <TopHeader
                    customTitle={customTitle}
                    isSectionLabelVisible={match.isMobile || match.isTablet}
                    actions={actions}
                />
            </>
        )}
    </MediaQuery>
);

/**
 * The white header at the top of the page with the Getrix logo on the left
 */
export const DefaultTopHeaderPortal: React.FC<DefaultTopHeaderProps> = ({
    actions,
    customTitle,
}) => {
    const headerElement = document.getElementById('header');
    return headerElement ? (
        createPortal(
            <DefaultTopHeader customTitle={customTitle} actions={actions} />,
            headerElement
        )
    ) : (
        <></>
    );
};
